import { http } from '../../services/api.services';

export const BranchService = {
  getBranches: params => http.get('/branches', { params }),
};
